'use client';

import { Button, TextPassage } from '@petsmart-ui/sparky';
import { useCallback, useEffect, useState } from 'react';

import { clsx, HtmlStringToReact } from '@libs/common-next';
import { ResponsivePicture } from '@libs/shared-ui';

import { ProductDescriptionTabHtmlProps } from '../types';
import '../ProductDescription.scss';

const MAXIMUMHEIGHT = 350;
const IMG_SIZE_SIZECHART = {
    width: 500,
    height: 500,
};

export const ProductDescriptionTabHtml = ({ htmlString, sizeChartImgUrl, title }: ProductDescriptionTabHtmlProps) => {
    const [shouldDisplayButton, setShouldDisplayButton] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const [dimensions, setDimensions] = useState<DOMRect>();

    const callBackRef = useCallback((domNode: HTMLDivElement) => {
        if (domNode) {
            setDimensions(domNode.getBoundingClientRect());
        }
    }, []);

    const hasSizeChart = sizeChartImgUrl && title === 'Size';

    const wrapperClasses = clsx('description-tab-wrapper', (isExpanded || hasSizeChart) && 'expanded');

    useEffect(() => {
        const textPassageHeight = dimensions?.height;

        // Don't show button for Size tab with size chart, otherwise show if content is tall
        if (!hasSizeChart && textPassageHeight && textPassageHeight > MAXIMUMHEIGHT) {
            setShouldDisplayButton(true);
        }
    }, [dimensions?.height, htmlString, hasSizeChart]);

    const onToggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <>
            <div className={wrapperClasses}>
                <div ref={callBackRef} className="description-tab-content">
                    <TextPassage capLinelength={false}>
                        <HtmlStringToReact htmlString={htmlString} />
                    </TextPassage>
                    {sizeChartImgUrl && title === 'Size' && (
                        <ResponsivePicture
                            src={sizeChartImgUrl}
                            size={IMG_SIZE_SIZECHART}
                            alt="Size chart"
                            className="description-tab-image"
                        />
                    )}
                </div>
            </div>
            {shouldDisplayButton && (
                <Button
                    className="see-more-button"
                    variant="link"
                    text={isExpanded ? 'See less' : 'See more'}
                    onClick={onToggleExpand}
                />
            )}
        </>
    );
};
